<template>
  <div class="input-group we-file-uploader">
    <div v-if="this.file.file" role="div" class="uploaded-image">
      <span @click="changeFile">
        <we-file :initial-file='file'>
        </we-file>
      </span>
    </div>
    <div v-if="!!file.file" class="action-buttons">
      <button class="delete" @click='deleteFile'><vs-icon icon="delete" ></vs-icon></button>
      <button class="refresh" v-if='!(file.errors)' @click='changeFile' ><vs-icon icon="refresh"></vs-icon></button>
    </div>
    <div v-if='file.errors' class="principal-image-list-text-error">
      <div :key="index" v-for='(error, index) in file.errors'>
        {{error}}
      </div>
    </div>
    <div>
      <div class="upload-container" :class="{selected: !!file.file}" ref='dropzone'>
        <button @click='addFile()' ref='newInputButton' class="upload-button" title="Agregue o arrastre la imagen que quiera cargar">
          <span class="upload-button--text"> {{ inputLabel }} </span>
          <span class="upload-button--icon">
            <vs-icon icon="folder_open"></vs-icon>
          </span>
        </button>
        <label>Logo de la entidad (opcional)</label>
      </div>
      <input @change='uploadFile' ref='fileInput' id='new-upload' type="file" accept="image/png, image/jpeg, image/jpg" class="form-control" style="display:none" multiple>
    </div>
  </div>
</template>

<script>
export default {
  name: 'we-file-uploader',
  props: {
    initialFile: {
      required: false,
      default: function () {
        return {}
      },
      acceptedExtensions: {
        type: String,
        required: false,
        default: "image/*"
      }
    }
  },
  mounted () {
    this.files = this.$props.initialFile
    this.$refs.dropzone.addEventListener('dragover', this.FileDragHover, false)
    this.$refs.dropzone.addEventListener('dragleave', this.FileDragLeave, false)
    this.$refs.dropzone.addEventListener('drop', this.FileDrop, false)
  },
  methods: {
    FileDragHover (e) {
      e.stopPropagation()
      e.preventDefault()
      this.draghover = true
    },
    FileDragLeave (e) {
      e.stopPropagation()
      e.preventDefault()
      this.draghover = false
    },
    FileDrop (e) {
      this.FileDragHover(e)
      // var file = e.target.files[0] || e.dataTransfer.files[0]
      this.uploadFile()
      this.draghover = false
    },
    addFile () {
      var vm = this
      vm.$refs.fileInput.click()
    },
    changeFile (file) {
      this.$refs.fileInput.click()
    },
    deleteFile (file) {
      this.file = {}
      this.$refs.fileInput.value = ''
      this.inputLabel = 'Logo de la entidad (opcional)'
      this.$emit('file-change', this.file)
    },
    uploadFile () {
      var fileToUpload = this.$refs.fileInput.files[0]
      if (fileToUpload.name.includes('.png') || fileToUpload.name.includes('.jpg') || fileToUpload.name.includes('.jpeg')) {
        var initialFile = { loading: true, file: {}, previewFile: fileToUpload, filesize: fileToUpload.size }
        var data = new FormData()
        data.append('file[image]', fileToUpload)
        this.file = initialFile
        this.file.previewImage = fileToUpload
        this.file.file = fileToUpload
        this.file.filesize = fileToUpload.size
        this.file.loading = true
        this.file.name = fileToUpload.name
        this.inputLabel = this.file.name
        this.$emit('file-change', this.file)
      } else {
        this.$emit('throwError') 
      }/*
      var initialFile = { loading: true, file: {}, previewFile: fileToUpload, filesize: fileToUpload.size }
      var data = new FormData()
      data.append('file[image]', fileToUpload)
      this.file = initialFile
      this.file.previewImage = fileToUpload
      this.file.file = fileToUpload
      this.file.filesize = fileToUpload.size
      this.file.loading = true
      this.file.name = fileToUpload.name
      this.inputLabel = this.file.name
      this.$emit('file-change', this.file)  */
    }
  },
  data: function () {
    return {
      draghover: false,
      inputLabel: 'Logo de la entidad (opcional)',
      file: {}
    }
  }
}
</script>
